import cn from "classnames";
import { FC, useState, InputHTMLAttributes } from "react";
import styles from "./MyTextarea.module.sass";

interface MyTextareaProps extends InputHTMLAttributes<HTMLInputElement> {
	name: string;
	placeholder: string;
	value: string;
	set: (e: any) => void;
	required?: boolean;
	error?: boolean;
	maxLength?: number;
	width?: string;
	resize?: string;
	readOnly?: boolean;
}

export const MyTextarea: FC<MyTextareaProps> = ({
	className,
	name,
	placeholder,
	value,
	set,
	required,
	error,
	maxLength,
	width,
	resize = "vertical",
	readOnly = false,
}) => {
	const [isFocus, setIsFocus] = useState<boolean>(false);

	return (
		<div className={cn(styles.wrp, styles[`${width}`])}>
			<span
				className={cn(
					`${isFocus ? styles["title-focus"] : styles.title}`,
					error && !value.trim() ? "error-input-title" : "",
				)}>
				{name}
				{required && <span className="red"> *</span>}
			</span>
			<div className={styles["textarea-wrp"]}>
				<textarea
					readOnly={readOnly}
					placeholder={placeholder}
					className={cn(
						styles.textarea,
						className,
						styles[`resize-${resize}`],
						error && !value.trim() ? "error-input" : "",
					)}
					value={value}
					maxLength={maxLength}
					onChange={set}
					onFocus={() => setIsFocus(true)}
					onBlur={() => setIsFocus(false)}></textarea>
				{!value && maxLength && <span className={styles.limit}>до {maxLength} символов</span>}
			</div>
		</div>
	);
};
